import React, { useEffect } from "react";
import { useLocation } from "react-router";

const StripeStatusRedirect = () => {
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();

  console.log("Stripe redirect query params:", query);
  
  const sessionId = query.get("session_id");
  const paymentStatus = query.get("payment_status");

  useEffect(() => {
    // Store Stripe session information
    if (sessionId) {
      localStorage.setItem("stripeSessionId", sessionId);
    }
    if (paymentStatus) {
      localStorage.setItem("stripePaymentStatus", paymentStatus);
    }

    // Set payment response status and message for success dialog (similar to PayPal)
    if (paymentStatus === "paid" || sessionId) {
      localStorage.setItem("payment_response_status", "success");
      localStorage.setItem("payment_response_message", "Payment completed successfully!");
    } else {
      localStorage.setItem("payment_response_status", "failed");
      localStorage.setItem("payment_response_message", "Payment was not completed.");
    }

    // Set the flag to trigger payment capture in the modal
    localStorage.setItem("addFundsClose", "true");
    
    const path = localStorage.getItem("REDIRECT_PATH");
    window.location.href = path;
  }, [sessionId, paymentStatus]);

  return <></>;
};

export default StripeStatusRedirect;